"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.reportWebPageView = exports.getMissingProperties = exports.BLIZZARD_ID = void 0;
const extraction_1 = require("./extraction");
const reporting_1 = require("./reporting");
const types_1 = require("./types");
const web_sentry_1 = require("@snapchat/web-sentry");
const graphene_1 = __importDefault(require("@snapchat/graphene"));
const web_env_1 = require("@snapchat/web-env");
const web_sc_cookies_1 = require("@snapchat/web-sc-cookies");
const serverReportingEndpointSuffix = "/web-page-view";
exports.BLIZZARD_ID = {
    TRACEID: "traceid",
    WEBCLIENTID: "webclientid",
    EMPTY: "",
};
// Get params that are just empty strings
const getMissingProperties = (webClientId, traceId) => {
    let missingProperty = exports.BLIZZARD_ID.EMPTY;
    const UNDERSCORE = "_";
    if (!traceId) {
        missingProperty = exports.BLIZZARD_ID.TRACEID;
    }
    if (!webClientId) {
        missingProperty +=
            missingProperty === "" ? exports.BLIZZARD_ID.WEBCLIENTID : UNDERSCORE + exports.BLIZZARD_ID.WEBCLIENTID;
    }
    return missingProperty;
};
exports.getMissingProperties = getMissingProperties;
function buildWebPageViewEvent({ webClientId, traceId, pageType, }) {
    if (!webClientId || !traceId) {
        if ((0, web_env_1.isRunningOnDevEnv)()) {
            console.error("Missing params for WebPageView event");
        }
        if (graphene_1.default.isReady()) {
            graphene_1.default.increment({
                metricsName: `BlizzardEvents.WebPageView.MissingParams.${types_1.PageType[pageType]}`,
                value: 1,
            });
            // log missing properties
            const missingProperties = (0, exports.getMissingProperties)(webClientId, traceId);
            graphene_1.default.increment({
                metricsName: "wpv.missing_property",
                dimensions: {
                    page: types_1.PageType[pageType],
                    missingProperties,
                },
            });
        }
        (0, web_sentry_1.logSentryError)(`Missing params for WebPageView Blizzard Event, WCID ${webClientId}, TraceID ${traceId}`);
        return;
    }
    return {
        webServerEventBase: (0, extraction_1.extractWebServerEventBase)(pageType, webClientId),
        traceId,
        encryptedIpAddress: "",
        utmCampaign: "",
        utmContent: "",
        utmMedium: "",
        utmSource: "",
        utmTerm: "",
        hasNonceCookieSet: (0, web_sc_cookies_1.hasNonceCookieSet)(),
    };
}
// This takes in WebClientID & TraceID
// Session id is added in https://github.sc-corp.net/Snapchat/web/blob/f4c9cd06fc08ff7e63f0dfecf1805b6e57d14a95/common/blizzard-reporting/extraction.ts#L58-L58
function reportWebPageView(params) {
    const webPageViewEvent = buildWebPageViewEvent(params);
    if (webPageViewEvent) {
        (0, reporting_1.reportServerEvent)(serverReportingEndpointSuffix, webPageViewEvent);
    }
}
exports.reportWebPageView = reportWebPageView;
//# sourceMappingURL=WebPageView.js.map